export interface CandidateRouter {
  goToCandidateDetail(): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidateRouter = Symbol('CandidateRouter');
